// extracted by mini-css-extract-plugin
export default {"input":"styles_input__lWzyC","buttons":"styles_buttons__S6hJQ","closeButton":"styles_closeButton__WhuvB","saveButton":"styles_saveButton__UKSsl"};